/**
 * @module sendingEmailAddresses
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { companyActions } from '~/behaviors/actions/company.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeSendingEmailAddresses = (state, action) => {
  const addresses = action?.payload?.entities?.sendingEmailAddresses || {};

  Object.values(addresses).forEach((address) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[address.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[address.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...address,
    };
  });
};

const sendingEmailAddresses = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(companyActions.fetchSendingEmailAddresses.fulfilled, mergeSendingEmailAddresses);
});

export default sendingEmailAddresses;
